function dateFormatter({
  date,
  format,
}: {
  date: string | Date;
  format: 'YYYY-MM-DD' | 'YYYY-MM-DD HH:mm' | 'YYYY-MM-DD HH:mm:ss';
}) {
  const date_ = new Date(date);
  // var month = ("0" + (1 + date.getMonth())).slice(-2);
  // var day = ("0" + date.getDate()).slice(-2);

  let formattedDate = '';
  if (format === 'YYYY-MM-DD') {
    formattedDate = `${date_.getFullYear()}-${`0${1 + date_.getMonth()}`.slice(
      -2
    )}-${`0${date_.getDate()}`.slice(-2)}`;
  }

  if (format === 'YYYY-MM-DD HH:mm') {
    formattedDate = `${date_.getFullYear()}-${`0${1 + date_.getMonth()}`.slice(
      -2
    )}-${`0${date_.getDate()}`.slice(-2)} ${`0${date_.getHours()}`.slice(
      -2
    )}:${`0${date_.getMinutes()}`.slice(-2)}`;
  }

  if (format === 'YYYY-MM-DD HH:mm:ss') {
    formattedDate = `${date_.getFullYear()}-${`0${1 + date_.getMonth()}`.slice(
      -2
    )}-${`0${date_.getDate()}`.slice(-2)} ${`0${date_.getHours()}`.slice(
      -2
    )}:${`0${date_.getMinutes()}`.slice(-2)}:${`0${date_.getSeconds()}`.slice(
      -2
    )}`;
  }

  return formattedDate;
}

export { dateFormatter };
